import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { useLenis } from "@/hooks/useLenis";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { QuoteDialog } from "@/components/site/QuoteDialog";
import Home from "@/pages/Home";
import About from "@/pages/About";

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function Layout() {
  useLenis();
  const [quoteOpen, setQuoteOpen] = useState(false);
  const [service, setService] = useState(null);

  const openQuote = (svc) => {
    setService(typeof svc === "string" ? svc : null);
    setQuoteOpen(true);
  };

  return (
    <>
      <ScrollTop />
      <Header onQuote={() => openQuote()} />
      <Routes>
        <Route path="/" element={<Home onQuote={openQuote} />} />
        <Route path="/about" element={<About onQuote={openQuote} />} />
      </Routes>
      <Footer onQuote={() => openQuote()} />
      <QuoteDialog open={quoteOpen} onOpenChange={setQuoteOpen} defaultService={service} />
      <Toaster position="top-center" richColors />
    </>
  );
}

export default function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <Layout />
      </BrowserRouter>
    </div>
  );
}
